import {ScriptsProvider} from '../providers/scriptsProvider';
import {ConfigProvider} from '../config/configProvider';
import {GoogleOptimize} from './googleOptimize';
import {ReadyProvider} from '../providers/readyProvider';

class GoogleAnalytics
{
    constructor() {
        this.analyticsV4Code = ConfigProvider.get('google-analytics-v4');
        this.analyticsCode = ConfigProvider.get('google-analytics');
        this.tagManagerCode = ConfigProvider.get('google-tag-manager');

        this.analyticsV4Source = 'https://www.googletagmanager.com/gtag/js?id=' + this.analyticsV4Code;
        this.analyticsSource = 'https://www.google-analytics.com/analytics.js';

        this._loadScript();
    }

    _loadAnalytics() {
        ReadyProvider.executeWithLazy(() => {
            if (!ScriptsProvider.has(this.analyticsSource)) {
                ScriptsProvider.add(this.analyticsSource);
            }
        });

        if (!window.ga) {
            window.ga = window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l += new Date;
            ga('create', this.analyticsCode, 'auto');
            ga('send', 'pageview');
        }
    }

    _loadAnalyticsV4() {
        ReadyProvider.executeWithLazy(() => {
            if (!ScriptsProvider.has(this.analyticsV4Source)) {
                ScriptsProvider.add(this.analyticsV4Source);
            }
        });

        if (!window.dataLayer) {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', this.analyticsV4Code);
        }
    }

    _loadScript() {
        if (this.analyticsCode) {
            this._loadAnalytics();
        }

        if (this.analyticsV4Code) {
            this._loadAnalyticsV4();
        }
    }

    _loadOptimize() {
        new GoogleOptimize();
    }

    _send(group, name) {
        if (typeof window.ga === 'function') {
            ga('send', 'event', {
                eventCategory: group,
                eventAction: name,
                eventLabel: location.pathname,
                nonInteraction: true,
            });
        }

        if (window.dataLayer && typeof window.gtag === 'function') {
            gtag('event', group + '_' + name, {
                'page_path': location.pathname,
                'group': group,
                'name': name,
            });
        }

        if (this.tagManagerCode) {
            setTimeout(() => this._send(group, name), 200);
        }
    }
}

export {GoogleAnalytics};
